import { TextShimmer } from "@/components/text-shimmer";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";

import { useAppSelector } from "@/redux/hooks";
import React from "react";

type HotelAccordionProps = {
  value: string;
  label: string;
  children: React.ReactNode;
  className?: string;
};

export const HotelAccordion: React.FC<HotelAccordionProps> = ({
  value,
  label,
  children,
  className,
}) => {
  const isLoading = useAppSelector(
    (state) => state.selectedHotelData.isLoading,
  );

  return (
    <AccordionItem
      value={value}
      className={cn("", className)}
      disabled={isLoading}
    >
      <AccordionTrigger className="hover:no-underline py-2.5 px-4 font-semibold">
        <div className="flex items-center gap-2 overflow-hidden">
          {isLoading ? (
            <TextShimmer duration={4}>{label}</TextShimmer>
          ) : (
            <span className="truncate block">{label}</span>
          )}
        </div>
      </AccordionTrigger>
      <AccordionContent className="space-y-4 pt-3 px-4 h-auto!">
        {children}
      </AccordionContent>
    </AccordionItem>
  );
};
